import moment from 'moment';
import { CONTRAT_ETAT_ENREGISTRE } from '@/configuration/baux/contrat/contratConf';

export default function genererCritereRechercheContratReconductible() {
  return {
    auto: null,
    tacite: null,
    naturesId: [],
    contratType: [],
    termePaiement: [],
    etat: [CONTRAT_ETAT_ENREGISTRE],
    dateFinEcheance: null,
    datePreavis: {
      dateDebut: moment(new Date()).startOf('month').toDate(),
      dateFin: moment(new Date()).endOf('month').toDate(),
    },
    agencesId: [],
    codesFace: [],
  };
}
